export const INSTALLMENT_INTEREST_RATE = 0.037; // Taxa de juros mensal 3.70%
